module.exports = __webpack_public_path__ + "fonts/Lufthansa Text Light.92048823.eot";